// extracted by mini-css-extract-plugin
module.exports = {"content":"sidebar_content__pEl1N","logoContainer":"sidebar_logoContainer__9GYuK","logo":"sidebar_logo__3p-a4","logoText":"sidebar_logoText__1bwGP","body":"sidebar_body__gqRB_"};